import featureProfile from "../../api/featureProfile.js";

// initial state
const state = () => ({
  profile: null,
});

// getters
const getters = {
  pstnEnabled(state) {
    if (!state.profile) return null;
    return state.profile.includes("pstn");
  },
  diversionsEnabled(state) {
    if (!state.profile) return null;
    return state.profile.includes("diversions");
  },
  broadcastCallsEnabled(state) {
    if (!state.profile) return null;
    return state.profile.includes("broadcast_calls");
  },
};

// actions
async function fetchProfile({ commit }) {
  const response = await featureProfile.getFeatureProfiles();
  const currentProfile = response.data.feature_profiles.find(
    (feature_profile) =>
      feature_profile.type === response.data.current_profile_type,
  );
  if (currentProfile) {
    commit("setProfile", currentProfile.features);
  }
}

async function featureEnabled({ dispatch, state }, feature) {
  if (state.profile === null) {
    await dispatch("fetchProfile");
  }
  return state.profile.includes(feature);
}

const actions = {
  fetchProfile,
  featureEnabled,
};

// mutations
const mutations = {
  setProfile(state, profile) {
    state.profile = profile;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
